import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuItemsWrapper = styled(Box)`
  display: flex;
`;
